var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ci-root" },
    [
      _vm.isLovable
        ? _c(
            "div",
            {
              ref: "comment",
              staticClass: "comment-box comment-box--lovable",
              class: {
                active: _vm.comment.selected || _vm.isHighlighted,
                resolved: !!_vm.comment.resolved,
              },
              attrs: { "data-comment-id": _vm.comment.id },
              on: { click: _vm.toggleComment },
            },
            [
              _c("div", { staticClass: "ci-lovable" }, [
                _c("div", { staticClass: "ci-lovable__row" }, [
                  _c(
                    "div",
                    { staticClass: "ci-lovable__body" },
                    [
                      _c("div", { staticClass: "ci-lovable__meta" }, [
                        _c("span", {
                          staticClass: "ci-lovable__dot",
                          style: {
                            backgroundColor: _vm.colorForUser(
                              _vm.comment.user_id
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ci-lovable__name" }, [
                          _vm._v(_vm._s(_vm.comment.user_name)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName:
                                  "v-b-tooltip.hover.viewport.noninteractive",
                                value: { title: _vm.comment.date_time },
                                expression: "{title: comment.date_time}",
                                modifiers: {
                                  hover: true,
                                  viewport: true,
                                  noninteractive: true,
                                },
                              },
                            ],
                            staticClass: "ci-lovable__ago",
                          },
                          [
                            _vm.comment.edited
                              ? _c("span", [_vm._v("edited ")])
                              : _vm._e(),
                            _vm._v(_vm._s(_vm.comment.ago) + "\n            "),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.comment.view_mode || _vm.comment.is_previous_version
                        ? _c(
                            "div",
                            { staticClass: "ci-lovable__view" },
                            [
                              _vm.comment.view_mode
                                ? [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.comment.view_mode) +
                                        _vm._s(
                                          String(
                                            _vm.comment.view_mode
                                          ).includes("view") ||
                                            /^\d/.test(_vm.comment.view_mode)
                                            ? ""
                                            : " view"
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.comment.view_mode &&
                              _vm.comment.is_previous_version
                                ? [_vm._v("\n              ·\n            ")]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.comment.is_previous_version
                                ? [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.comment.source_version_name
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isEditingThis
                        ? _c("CommentInput", {
                            attrs: {
                              "editing-comment-id": _vm.comment.id,
                              "edited-comment": _vm.comment.comment,
                            },
                          })
                        : _c(
                            "div",
                            { staticClass: "ci-lovable__text" },
                            [
                              _vm.comment.status === "draft"
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-danger font-weight-bold",
                                    },
                                    [_vm._v("Draft: ")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("RichTextDisplay", {
                                staticClass: "ci-lovable__html",
                                attrs: { html: _vm.comment.comment },
                              }),
                              _vm._v(" "),
                              _vm.comment.status === "approved" ||
                              _vm.comment.resolved
                                ? _c("div", { staticClass: "mt-1 mb-0" }, [
                                    _vm.comment.status === "approved"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ci-lovable__status ci-lovable__status--ok",
                                          },
                                          [
                                            _vm._v(
                                              "\n                Approved\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.comment.resolved &&
                                    !_vm.comment.parent_id
                                      ? _c(
                                          "span",
                                          { staticClass: "ci-lovable__status" },
                                          [
                                            _vm._v(
                                              "\n                Resolved\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _vm.comment.video_url && !_vm.isEditingThis
                        ? _c("div", { staticClass: "video mt-3" }, [
                            _c("video", {
                              attrs: {
                                id: `comment-video-${_vm.comment.id}`,
                                width: "200",
                                controls: "",
                                src: _vm.comment.video_url,
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("AttachmentChips", {
                        attrs: {
                          download: "",
                          references: _vm.commentAttachments,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.actions && !_vm.showCommentBox
                    ? _c(
                        "div",
                        {
                          staticClass: "ci-lovable__actions",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName:
                                    "v-b-tooltip.hover.viewport.noninteractive",
                                  value: "Reply",
                                  expression: "'Reply'",
                                  modifiers: {
                                    hover: true,
                                    viewport: true,
                                    noninteractive: true,
                                  },
                                },
                              ],
                              staticClass: "ci-lovable__btn",
                              attrs: {
                                type: "button",
                                "aria-label": "Reply",
                                title: "Reply",
                              },
                              on: { click: _vm.replyToComment },
                            },
                            [
                              _c("Undo2", {
                                staticClass: "vp-i",
                                attrs: { size: 24, "stroke-width": 2 },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.comment.editable && !_vm.comment.resolved
                            ? _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName:
                                        "v-b-tooltip.hover.viewport.noninteractive",
                                      value: "Edit",
                                      expression: "'Edit'",
                                      modifiers: {
                                        hover: true,
                                        viewport: true,
                                        noninteractive: true,
                                      },
                                    },
                                  ],
                                  staticClass: "ci-lovable__btn",
                                  attrs: {
                                    type: "button",
                                    "aria-label": "Edit",
                                    title: "Edit",
                                  },
                                  on: { click: _vm.editComment },
                                },
                                [
                                  _c("Pencil", {
                                    staticClass: "vp-i",
                                    attrs: { size: 24, "stroke-width": 2 },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.comment.status !== "approved" &&
                          _vm.comment.status !== "draft" &&
                          !_vm.comment.parent_id
                            ? _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName:
                                        "v-b-tooltip.hover.viewport.noninteractive",
                                      value: "Approve",
                                      expression: "'Approve'",
                                      modifiers: {
                                        hover: true,
                                        viewport: true,
                                        noninteractive: true,
                                      },
                                    },
                                  ],
                                  staticClass: "ci-lovable__btn",
                                  attrs: {
                                    type: "button",
                                    "aria-label": "Approve",
                                    title: "Approve",
                                    disabled: _vm.comment.isApproving,
                                  },
                                  on: { click: _vm.approveComment },
                                },
                                [
                                  _c("Check", {
                                    staticClass: "vp-i",
                                    attrs: { size: 24, "stroke-width": 2 },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.comment.resolved &&
                          _vm.comment.status !== "draft" &&
                          !_vm.comment.parent_id
                            ? _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName:
                                        "v-b-tooltip.hover.viewport.noninteractive",
                                      value: "Resolve",
                                      expression: "'Resolve'",
                                      modifiers: {
                                        hover: true,
                                        viewport: true,
                                        noninteractive: true,
                                      },
                                    },
                                  ],
                                  staticClass: "ci-lovable__btn",
                                  attrs: {
                                    type: "button",
                                    "aria-label": "Resolve",
                                    title: "Resolve",
                                    disabled: _vm.comment.isResolving,
                                  },
                                  on: { click: _vm.resolveComment },
                                },
                                [
                                  _c("Redo2", {
                                    staticClass: "vp-i",
                                    attrs: { size: 24, "stroke-width": 2 },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.comment.deletable
                            ? _c(
                                "BtnDelete",
                                {
                                  staticClass: "delete-comment",
                                  attrs: {
                                    variant: "link",
                                    size: "sm",
                                    "button-class":
                                      "ci-lovable__btn ci-lovable__btn--danger",
                                    "confirmation-html":
                                      "Are you sure you want to delete this comment?",
                                  },
                                  on: { confirm: _vm.deleteComment },
                                },
                                [
                                  _c("Trash2", {
                                    staticClass: "vp-i",
                                    attrs: { size: 24, "stroke-width": 2 },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm.comment.replies_recursive &&
              _vm.comment.replies_recursive.length
                ? _c(
                    "div",
                    { staticClass: "ci-lovable__replies" },
                    _vm._l(_vm.comment.replies_recursive, function (reply) {
                      return _c("CommentItem", {
                        key: reply.id,
                        attrs: {
                          comment: reply,
                          scroll: false,
                          actions: _vm.actions,
                          "compact-actions": _vm.compactActions,
                          variant: _vm.variant,
                          "show-proof-link": _vm.showProofLink,
                          "proof-share-link": _vm.proofShareLink,
                        },
                      })
                    }),
                    1
                  )
                : _vm._e(),
            ]
          )
        : _c(
            "b-card",
            {
              ref: "comment",
              staticClass: "mb-2 comment-box",
              class: {
                active: _vm.comment.selected || _vm.isHighlighted,
                resolved: !!_vm.comment.resolved,
              },
              attrs: { "body-class": "p-3", "data-comment-id": _vm.comment.id },
            },
            [
              _c(
                "div",
                { on: { click: _vm.toggleComment } },
                [
                  _c(
                    "b-form-row",
                    [
                      _c("b-col", [
                        _c(
                          "div",
                          { staticClass: "d-inline-flex flex-column" },
                          [
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _c("span", {
                                staticClass: "color-dot m-0",
                                style: {
                                  backgroundColor: _vm.colorForUser(
                                    _vm.comment.user_id
                                  ),
                                },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.comment.user_name) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.comment.view_mode ||
                            _vm.comment.is_previous_version
                              ? _c(
                                  "span",
                                  { staticClass: "font-italic font-sm" },
                                  [
                                    _vm.comment.view_mode
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.comment.view_mode) +
                                              " view\n              "
                                          ),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.comment.view_mode &&
                                    _vm.comment.is_previous_version
                                      ? [
                                          _vm._v(
                                            "\n                ·\n              "
                                          ),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.comment.is_previous_version
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.comment.source_version_name
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName:
                                  "v-b-tooltip.hover.viewport.noninteractive",
                                value: { title: _vm.comment.date_time },
                                expression: "{title: comment.date_time}",
                                modifiers: {
                                  hover: true,
                                  viewport: true,
                                  noninteractive: true,
                                },
                              },
                            ],
                            staticClass: "text-nowrap text-muted font-sm",
                          },
                          [
                            _vm.comment.edited
                              ? _c("span", [_vm._v("edited")])
                              : _vm._e(),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.comment.ago) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.actions && !_vm.showCommentBox && _vm.compactActions
                        ? _c(
                            "b-col",
                            {
                              staticClass:
                                "d-flex align-self-start align-items-end",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName:
                                        "v-b-tooltip.hover.viewport.noninteractive",
                                      value: "Reply",
                                      expression: "'Reply'",
                                      modifiers: {
                                        hover: true,
                                        viewport: true,
                                        noninteractive: true,
                                      },
                                    },
                                  ],
                                  staticClass: "comment-action-btn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.replyToComment.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("Reply", {
                                    staticClass: "comment-action-btn__icon",
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.comment.editable && !_vm.comment.resolved
                                ? _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName:
                                            "v-b-tooltip.hover.viewport.noninteractive",
                                          value: "Edit",
                                          expression: "'Edit'",
                                          modifiers: {
                                            hover: true,
                                            viewport: true,
                                            noninteractive: true,
                                          },
                                        },
                                      ],
                                      staticClass: "comment-action-btn",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.editComment.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("Pencil", {
                                        staticClass: "comment-action-btn__icon",
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.comment.resolved &&
                              _vm.comment.status !== "draft" &&
                              !_vm.comment.parent_id
                                ? _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName:
                                            "v-b-tooltip.hover.viewport.noninteractive",
                                          value: "Mark as updated",
                                          expression: "'Mark as updated'",
                                          modifiers: {
                                            hover: true,
                                            viewport: true,
                                            noninteractive: true,
                                          },
                                        },
                                      ],
                                      staticClass: "comment-action-btn",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.comment.isResolving,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.resolveComment.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("CircleCheck", {
                                        staticClass: "comment-action-btn__icon",
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.comment.status !== "approved" &&
                              _vm.comment.status !== "draft" &&
                              !_vm.comment.parent_id
                                ? _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName:
                                            "v-b-tooltip.hover.viewport.noninteractive",
                                          value: "Mark as approved",
                                          expression: "'Mark as approved'",
                                          modifiers: {
                                            hover: true,
                                            viewport: true,
                                            noninteractive: true,
                                          },
                                        },
                                      ],
                                      staticClass: "comment-action-btn",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.comment.isApproving,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.approveComment.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("BadgeCheck", {
                                        staticClass: "comment-action-btn__icon",
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.comment.deletable
                                ? _c(
                                    "BtnDelete",
                                    {
                                      staticClass: "delete-comment",
                                      attrs: {
                                        variant: "link",
                                        "button-class":
                                          "comment-action-btn comment-action-btn--delete p-0",
                                        "confirmation-html":
                                          "Are you sure you want to delete this comment?",
                                      },
                                      on: { confirm: _vm.deleteComment },
                                    },
                                    [
                                      _c("Trash2", {
                                        staticClass: "comment-action-btn__icon",
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm.actions && !_vm.showCommentBox
                        ? _c(
                            "b-col",
                            {
                              staticClass: "d-flex align-self-start",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName:
                                        "v-b-tooltip.hover.viewport.noninteractive",
                                      value: "Reply",
                                      expression: "'Reply'",
                                      modifiers: {
                                        hover: true,
                                        viewport: true,
                                        noninteractive: true,
                                      },
                                    },
                                  ],
                                  staticClass: "rounded-circle d-flex p-1 mr-1",
                                  attrs: {
                                    variant: "outline-primary",
                                    size: "sm",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.replyToComment.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_c("b-icon", { attrs: { icon: "reply" } })],
                                1
                              ),
                              _vm._v(" "),
                              _vm.comment.editable && !_vm.comment.resolved
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName:
                                            "v-b-tooltip.hover.viewport.noninteractive",
                                          value: "Edit",
                                          expression: "'Edit'",
                                          modifiers: {
                                            hover: true,
                                            viewport: true,
                                            noninteractive: true,
                                          },
                                        },
                                      ],
                                      staticClass:
                                        "rounded-circle d-flex p-1 mr-1",
                                      attrs: {
                                        variant: "outline-secondary",
                                        size: "sm",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.editComment.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("b-icon", {
                                        attrs: { icon: "pencil" },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.comment.resolved &&
                              _vm.comment.status !== "draft" &&
                              !_vm.comment.parent_id
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName:
                                            "v-b-tooltip.hover.viewport.noninteractive",
                                          value: "Mark as updated",
                                          expression: "'Mark as updated'",
                                          modifiers: {
                                            hover: true,
                                            viewport: true,
                                            noninteractive: true,
                                          },
                                        },
                                      ],
                                      staticClass:
                                        "rounded-circle d-flex p-1 mr-1",
                                      attrs: {
                                        variant: "outline-success",
                                        size: "sm",
                                        disabled: _vm.comment.isResolving,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.resolveComment.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("b-icon", {
                                        attrs: {
                                          icon: "check",
                                          scale: "1.5",
                                          animation: _vm.comment.isResolving
                                            ? "throb"
                                            : "",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.comment.status !== "approved" &&
                              _vm.comment.status !== "draft" &&
                              !_vm.comment.parent_id
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName:
                                            "v-b-tooltip.hover.viewport.noninteractive",
                                          value: "Mark as approved",
                                          expression: "'Mark as approved'",
                                          modifiers: {
                                            hover: true,
                                            viewport: true,
                                            noninteractive: true,
                                          },
                                        },
                                      ],
                                      staticClass:
                                        "rounded-circle d-flex p-1 mr-1",
                                      attrs: {
                                        variant: "outline-success",
                                        size: "sm",
                                        disabled: _vm.comment.isApproving,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.approveComment.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("b-icon", {
                                        attrs: {
                                          icon: "patch-check",
                                          animation: _vm.comment.isApproving
                                            ? "throb"
                                            : "",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.comment.deletable
                                ? _c("BtnDelete", {
                                    staticClass: "delete-comment",
                                    attrs: {
                                      variant: "outline-danger",
                                      "button-class":
                                        "rounded-circle d-flex p-1",
                                      "confirmation-html":
                                        "Are you sure you want to delete this comment?",
                                    },
                                    on: { confirm: _vm.deleteComment },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12" } }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isEditingThis
                    ? _c("CommentInput", {
                        staticClass: "mt-2",
                        attrs: {
                          "editing-comment-id": _vm.comment.id,
                          "edited-comment": _vm.comment.comment,
                        },
                      })
                    : _c(
                        "div",
                        { staticClass: "mt-2" },
                        [
                          _vm.comment.status === "draft"
                            ? _c(
                                "span",
                                { staticClass: "text-danger font-weight-bold" },
                                [_vm._v("Draft: ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("RichTextDisplay", {
                            staticClass: "card-text d-inline-block mb-1",
                            attrs: { html: _vm.comment.comment },
                          }),
                          _vm._v(" "),
                          _vm.comment.status === "approved" ||
                          _vm.comment.resolved
                            ? _c("div", { staticClass: "mt-1 mb-0" }, [
                                _vm.comment.status === "approved"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-success badge-sm mr-1",
                                        staticStyle: {
                                          "font-size": "0.7rem",
                                          padding: "2px 6px",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-check",
                                          staticStyle: {
                                            "font-size": "0.65rem",
                                          },
                                        }),
                                        _vm._v(" Approved\n          "),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.comment.resolved && !_vm.comment.parent_id
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-info badge-sm",
                                        staticStyle: {
                                          "font-size": "0.7rem",
                                          padding: "2px 6px",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-check-circle",
                                          staticStyle: {
                                            "font-size": "0.65rem",
                                          },
                                        }),
                                        _vm._v(" Resolved\n          "),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showProofLink &&
                          _vm.comment.options &&
                          _vm.proofShareLink
                            ? _c("div", { staticClass: "mt-2" }, [
                                _c("small", [
                                  _c("i", {
                                    staticClass: "fa fa-map-pin text-muted",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-primary",
                                      attrs: {
                                        href: _vm.getProofPageUrl(),
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              View on proof page →\n            "
                                      ),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _vm.comment.video_url && !_vm.isEditingThis
                    ? _c("div", { staticClass: "video mt-3" }, [
                        _c("video", {
                          attrs: {
                            id: `comment-video-${_vm.comment.id}`,
                            width: "200",
                            controls: "",
                            src: _vm.comment.video_url,
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("AttachmentChips", {
                    attrs: { download: "", references: _vm.commentAttachments },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.comment.replies_recursive &&
              _vm.comment.replies_recursive.length
                ? _c(
                    "div",
                    { staticClass: "mt-2" },
                    _vm._l(_vm.comment.replies_recursive, function (reply) {
                      return _c("CommentItem", {
                        key: reply.id,
                        attrs: {
                          comment: reply,
                          scroll: false,
                          actions: _vm.actions,
                          "compact-actions": _vm.compactActions,
                          variant: _vm.variant,
                          "show-proof-link": _vm.showProofLink,
                          "proof-share-link": _vm.proofShareLink,
                        },
                      })
                    }),
                    1
                  )
                : _vm._e(),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }